<template>
  <a-modal
    :visible="open"
    :title="null"
    :width="480"
    :confirm-loading="submitLoading"
    :mask-closable="false"
    @cancel="handleCancel"
    @ok="handleConfirm"
  >
    <div class="confirm-settle-header">
      <a-icon type="exclamation-circle" theme="filled" class="confirm-settle-icon" />
      <span>{{ $t('确认签收? 19:00 前签收,19:00到账, 19:00后签收 次日 19:00到账') }}</span>
    </div>
    <div class="confirm-settle-files">
      <div v-for="item in fileFields" :key="item.key" class="confirm-settle-file-item">
        <a-icon type="file-pdf" class="file-icon" />
        <span class="file-label">{{ $t(item.label) }}</span>
        <a
          v-if="files[item.key]"
          class="file-status uploaded"
          @click.prevent="downloadFile(item.key)"
        >[{{ $t('已上传') }}]</a>
        <span v-else class="file-status not-uploaded">[{{ $t('未上传') }}]</span>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { getSchoolBatchChangeLog, settleSchoolBatchChangeLog } from '@/api/school/schoolBatchChangeLog'

export default {
  name: 'ConfirmSettleModal',
  data () {
    return {
      open: false,
      submitLoading: false,
      recordId: null,
      files: {
        satisfactionFile: null,
        acceptanceFile: null,
        signFile: null,
        otherFile: null
      },
      fileFields: [
        { key: 'satisfactionFile', label: '满意度调查表' },
        { key: 'acceptanceFile', label: '验收单' },
        { key: 'signFile', label: '签收单' },
        { key: 'otherFile', label: '其他文件' }
      ]
    }
  },
  methods: {
    handleOpen (record) {
      this.recordId = record.id
      this.open = true
      this.files = {
        satisfactionFile: null,
        acceptanceFile: null,
        signFile: null,
        otherFile: null
      }
      getSchoolBatchChangeLog({ id: record.id }).then(res => {
        const data = res.data || {}
        this.files.satisfactionFile = this.parseFileField(data.satisfactionFile)
        this.files.acceptanceFile = this.parseFileField(data.acceptanceFile)
        this.files.signFile = this.parseFileField(data.signFile)
        this.files.otherFile = this.parseFileField(data.otherFile)
      })
    },
    parseFileField (value) {
      if (!value) return null
      if (typeof value === 'object') return value.filePath ? value : null
      try {
        const obj = JSON.parse(value)
        return obj && obj.filePath ? obj : null
      } catch (e) {
        return { fileName: value.split('/').pop(), filePath: value }
      }
    },
    downloadFile (fieldKey) {
      const file = this.files[fieldKey]
      if (!file || !file.filePath) return
      const link = document.createElement('a')
      link.href = file.filePath
      link.download = file.fileName || file.filePath.split('/').pop().split('?')[0] || 'download'
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    handleCancel () {
      this.open = false
      this.recordId = null
    },
    handleConfirm () {
      if (!this.recordId) return
      this.submitLoading = true
      return settleSchoolBatchChangeLog({ id: this.recordId })
        .then(() => {
          this.$message.success(this.$t('签收成功'))
          this.open = false
          this.$emit('ok')
        })
        .finally(() => {
          this.submitLoading = false
        })
    }
  }
}
</script>

<style scoped>
.confirm-settle-header {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 20px;
  line-height: 1.5;
}
.confirm-settle-icon {
  color: #faad14;
  font-size: 22px;
  margin-top: 2px;
}
.confirm-settle-files {
  padding-left: 30px;
}
.confirm-settle-file-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.file-icon {
  font-size: 18px;
  color: #ff4d4f;
  margin-right: 8px;
}
.file-label {
  flex: 1;
}
.file-status.uploaded {
  color: #1890ff;
  cursor: pointer;
}
.file-status.uploaded:hover {
  text-decoration: underline;
}
.file-status.not-uploaded {
  color: #999;
}
</style>
